import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataSupplier(params) {
	return client.get("api/supplier/data", {
		params: params,
	});
}

function exportSupplier(params) {
	return client.get("api/supplier/export", {
		params: params,
	});
}

function addSupplier(params) {
	return client.post("api/supplier/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateSupplier(params) {
	return client.post("api/supplier/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteSupplier(params) {
	return client.post("api/supplier/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusSupllier(params) {
	return client.post("api/supplier/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getDataSupplierProduct(params) {
	return client.get("api/supplier-product/data", {
		params: params,
	});
}

function addSupplierProduct(params) {
	return client.post("api/supplier-product/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateSupplierProduct(params) {
	return client.post("api/supplier-product/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteSupplierProduct(params) {
	return client.post("api/supplier-product/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataSupplier,
	exportSupplier,
	addSupplier,
	updateSupplier,
	deleteSupplier,
	statusSupllier,
	getDataSupplierProduct,
	addSupplierProduct,
	updateSupplierProduct,
	deleteSupplierProduct
};